import {calculateAgeAtDate} from "../../util";

/**
 * Provided with a list of anfallsanamnese and TUs, infers the diagnose using a clinical algorithm
 * @param anfaelle a list of anfallsanamnese
 * @param technischeUntersuchungen a list of tus
 * @param patBirthDate patient birthdate to calculate age first seizure
 * @param rules
 * @returns {string} A human readable string of the diagnose
 */
function inferDiagnose(anfaelle, technischeUntersuchungen, patBirthDate, rules) {
    let patientInfo = {
        "ALTER_ERSTMANIFESTATION": calculateAlterErsterAnfall(anfaelle, patBirthDate),
        "ANFAELLE": mapAnfaelle(anfaelle),
        "TU": mapTU(technischeUntersuchungen)
    }
    console.log({
        "msg": "inferDiagnose for anfaelleAlgorithm",
        "component": "diagnose",
        "ALTER_ERSTMANIFESTATION": patientInfo["ALTER_ERSTMANIFESTATION"],
        "ANFAELLE": patientInfo["ANFAELLE"],
        "TU": patientInfo["TU"]
    })
    return findDiagnose(patientInfo, rules);
}

function calculateAlterErsterAnfall(anfaelle, patBirthDate) {
    console.log({
        "msg": "Calculate Age first 'Anfall'",
        "component": "diagnose"
    })
    if (anfaelle.length !== 0) {
        const firstAnfall = anfaelle.map(anfall => anfall.datum).sort()[0]
        let ageAtFirstAnfall = calculateAgeAtDate(patBirthDate,firstAnfall);
        if (ageAtFirstAnfall <= 20) {
            console.log({
                "msg": "Calculate Age first 'Anfall' is: minor of 20",
                "component": "diagnose",
                "ageAtFirstAnfall": ageAtFirstAnfall
            })
            return "1"
        } else {
            console.log({
                "msg": "Calculate Age first 'Anfall' is: older of 20",
                "component": "diagnose",
                "ageAtFirstAnfall": ageAtFirstAnfall
            })
            return "2"
        }
    } else {
        console.log({
            "msg": "the given anfaelle list doesn't have an entry",
            "anfaelle": anfaelle,
            "component": "diagnose"
        })
        return undefined
    }
}

function mapTU(technischeUntersuchungen) {
    console.log({
        "msg": "map TU from technischeUntersuchungen list",
        "component": "diagnose"
    })
    let result = {"EEG": [], "MRT": [], "CCT": []}
    technischeUntersuchungen.forEach(tu => result[tu.value['MODALITY']].push(tu.value['FINDING_ID']))
    console.log({
        "msg": "The final mapped TU",
        "component": "diagnose",
        "mapTU": result
    })
    return result
}

function mapAnfaelle(anfaelle) {
    console.log({
        "msg": "map anfaelle from anfaelle list",
        "component": "diagnose"
    })
    let mapAnfallstypToAnfallKey = {
        "1": "FOKAL",
        "3": "MYOKLONISCH",
        "4": "UNKLAR",
        "11": "VA_ABSCENCE",
        "2": "GENERALISIERT",
        "99": "PSYCHOGENE"
    }
    let result = anfaelle.map(anfall => mapAnfallstypToAnfallKey[anfall.rowsUsed[anfall.rowsUsed.length - 1]["Anfalls_ID"]])
    console.log({
        "msg": "The final mapped anfaelle",
        "component": "diagnose",
        "mapAnfaelle": result
    })
    return result
}

function listOfAllPossibleDiagnoses(rules) {
    // This removes duplicates and makes the order alphabetical
    return [...new Set(rules.map(rule => rule['DIAGNOSE']))].sort()
}

/**
 * Provided with an object containing the patient information and infers the diagnose using a clinical algorithm
 * @param patientInfo an object containing patient information about: Abklärung durch Epileptologen erforderlich, Anfälle, TUs and Alter bei erster Erstmanifestation
 * @param rules
 * @returns A JSONObject containing the full line of the rule that is fulfilled from the "diagnose algorithm"
 */
function findDiagnose(patientInfo, rules) {
    console.log({
        "msg": "find diagnose with the given patient info",
        "component": "diagnose",
        "patientInfo": patientInfo
    })
    for (const rule of rules) {
        console.log({
            "Checking rule": rule["RULE_ID"]
        })
        if (isRuleSatisfied(rule, patientInfo)) {
            console.log({
                "msg": "rule was satisfied",
                "component": "diagnose",
                "rule": rule
            })
            return rule
        }
    }
    console.log({
        "msg": "the was no diagnose found for the given information",
        "patientInfo": patientInfo,
        "component": "diagnose"
    })
}

function isRuleSatisfied(rule, patientInfo) {
    let tuNeeded = tuNeededInRulePresent(rule, patientInfo)
    console.log("tuNeeded result: " + tuNeeded)
    return alterNeededInRulePresent(rule, patientInfo)
        && anfaelleNeededInRulePresent(rule, patientInfo)
        && tuNeeded
}


function alterNeededInRulePresent(rule, patientInfo) {
    console.log({
        "msg": "check if Age rule is fulfilled",
        "component": "diagnose"
    })
    let flagAlterErstMatched = true
    if (rule['ALTER_ERSTMANIFESTATION'] !== "x") {
        if (rule['ALTER_ERSTMANIFESTATION'] !== patientInfo['ALTER_ERSTMANIFESTATION']) {
            console.log({
                "msg": "Age rule WAS NOT fulfilled",
                "component": "diagnose"
            })
            flagAlterErstMatched = false
        }
    }
    if (flagAlterErstMatched) {
        console.log({
            "msg": "Age rule WAS fulfilled",
            "component": "diagnose"
        })
    }
    return flagAlterErstMatched
}

function anfaelleNeededInRulePresent(rule, patientInfo) {
    console.log({
        "msg": "check if Anfaelle needed in Rule is present",
        "component": "diagnose"
    })
    const anfaelle = ["FOKAL", "MYOKLONISCH", "VA_ABSCENCE", "GENERALISIERT", "UNKLAR", "PSYCHOGENE"]
    let relevantAnfaelle = reduceToRelevantEntity(rule, anfaelle, "x");
    console.log({
        "msg": "relevant Anfaelle for the rule",
        "component": "diagnose",
        "relevantAnfaelle": relevantAnfaelle
    })
    for (const anfall of relevantAnfaelle) {
        console.log({
            "msg": "check if given Anfall is present",
            "component": "diagnose",
            "anfall": anfall
        })
        if (rule[anfall] === "1") {
            if (!patientInfo['ANFAELLE'].includes(anfall)) {
                console.log({
                    "msg": "anfall NOT present",
                    "component": "diagnose"
                })
                return false
            }
        } else {
            if (patientInfo['ANFAELLE'].includes(anfall)) {
                console.log({
                    "msg": "anfall shouldn't be present",
                    "component": "diagnose"
                })
                return false
            }
        }
    }
    console.log({
        "msg": "anfall present",
        "component": "diagnose"
    })
    return true
}

function tuNeededInRulePresent(rule, patientInfo) {
    console.log({
        "msg": "check if TU needed in Rule is present",
        "component": "diagnose"
    })
    let relevantTUs = reduceToRelevantEntity(rule, ["EEG", "MRT", "CCT"], "x")
    console.log({
        "msg": "relevant TU for the rule",
        "component": "diagnose",
        "relevantTUs": relevantTUs
    })
    for (const tu of relevantTUs) {
        console.log({
            "msg": "check if given TU is present",
            "component": "diagnose",
            "tu": tu,
            "value": rule[tu]
        })
        let tuValue = rule[tu]
        if (tuValue.includes("UND")) {
            const tuValuesIndividual = tuValue.split(" UND ")
            for (const tuType of tuValuesIndividual) {
                if (tuType.includes("NICHT")) {
                    const regex = /\d+/g;
                    const matches = tuType.match(regex);
                    let result = true
                    matches.forEach(match => {
                        if (patientInfo['TU'][tu].includes(match)) {
                            console.log({
                                "msg": "one of the NOT needed TU is present",
                                "component": "diagnose"
                            })
                            result = false
                        }
                    })
                    if (result === false) {
                        return false
                    }
                } else if (tuType.includes("ODER")) {
                    const tuValuesIndividual = tuType.split(" ODER ")
                    if (!patientInfo['TU'][tu].some(tuType => tuValuesIndividual.includes(tuType))) {
                        console.log({
                            "msg": "one of the needed TU NOT present",
                            "component": "diagnose"
                        })
                        return false
                    }
                } else {
                    if (!patientInfo['TU'][tu].includes(tuType)) {
                        console.log({
                            "msg": "one of the needed TU NOT present",
                            "component": "diagnose"
                        })
                        return false
                    }
                }
            }
        } else if (tuValue.includes("ODER")) {
            const tuValuesIndividual = tuValue.split(" ODER ")
            if (!patientInfo['TU'][tu].some(tuType => tuValuesIndividual.includes(tuType))) {
                console.log({
                    "msg": "one of the needed TU NOT present",
                    "component": "diagnose"
                })
                return false
            }
        } else {
            if (tuValue.includes("NICHT")) {
                console.log("tuValue includes NICHT")
                const regex = /\d+/g;
                const matches = tuValue.match(regex);
                let result = true;
                matches.forEach(match => {
                    if (patientInfo['TU'][tu].includes(match)) {
                        console.log("one of the NOT needed TU is present LOOP")
                        console.log({
                            "msg": "one of the NOT needed TU is present",
                            "component": "diagnose"
                        })
                        result = false
                    }
                })
                if (result === false) {
                    return false
                }
            } else {
                let result = patientInfo.TU[tu].some(oneTu => oneTu === tuValue)
                if (result) {
                    console.log({
                        "msg": "needed TU present",
                        "component": "diagnose"
                    })
                } else {
                    console.log({
                        "msg": "one of the needed TU NOT present",
                        "component": "diagnose"
                    })
                    return result
                }
            }
        }
    }
    console.log({
        "msg": "all TU needed present",
        "component": "diagnose"
    })
    return true
}

/**
 * Use to determine which anfälle, TU or AND/OR need to be present to fulfill a rule
 * @param rule Object containing all the information of a rule
 * @param entity {*[]} Keys of entities that we want to check if it's relevant or not for the rule
 * @param valueUsedForIrrelevance The string or array that marks that an entity is irrelevant for the rule
 * @returns {*[]} An array containing the key from the entity that are relevant for the rule
 */
function reduceToRelevantEntity(rule, entity, valueUsedForIrrelevance) {
    return Object.keys(rule).filter(key => (entity.includes(key) && (rule[key] !== valueUsedForIrrelevance)))
}

export default {
    inferDiagnose: inferDiagnose,
    listOfAllPossibleDiagnoses: listOfAllPossibleDiagnoses
}
